import {
    Fragment,
} from 'react'
import { Menu, Transition } from '@headlessui/react'
import { classNames } from '@progress/kendo-react-common'
import { DropPosition } from '../common'
import React from 'react'

type GenericSingleSelectorProps = {
    disable?: boolean
    position?: DropPosition
    items: any[]
    selected_item: any
    itemDisplay:(item: any, index: number, is_selected: boolean) => JSX.Element
    titleDisplay:(item: any, is_open: boolean) => JSX.Element
    isItemSelected:(item: any, selected_item: any) => boolean
    options_class_name?: string
    class_name?: string
    button_class_name?: string
}

export function GenericSingleSelector(props: GenericSingleSelectorProps) {
    const {
        disable, 
        position,
        items,
        selected_item,
        itemDisplay,
        titleDisplay,
        isItemSelected,
        options_class_name,
        class_name,
        button_class_name
    } = props

    return (
        <Menu
            as="div"
            className={classNames(
                class_name,
                'relative inline-block text-left'
            )}
        >
            {({ open }) => (
                <>
                    <Menu.Button
                        disabled={disable}
                        className={classNames(
                            'inline-flex text-left uppercase items-center w-full',
                            'rounded-md border border-gray-150 shadow-xs p-2 bg-white',
                            'text-xs font-medium text-gray-700 disabled:bg-gray-100 disabled:hover:bg-gray-200 disabled:cursor-not-allowed hover:bg-gray-50 ',
                            button_class_name
                        )}
                    >
                        {titleDisplay(selected_item, open)}
                    </Menu.Button>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                        show={open}
                    >
                        <Menu.Items
                            static
                            className={classNames(
                                position,
                                'absolute mt-2',
                                'rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5',
                                'focus:outline-none z-10',
                                options_class_name
                            )}
                        >
                            <div className="p-2">
                                {items && items.length
                                    ? items.map(
                                        (
                                            i: any,
                                            index
                                        ) => {
                                            return (
                                                itemDisplay(i, index, isItemSelected(i, selected_item))
                                            )
                                        }
                                    )
                                    : ''}
                            </div>
                        </Menu.Items>
                    </Transition>
                </>
            )}
        </Menu>
    )
}

export default GenericSingleSelector
